<template>
  <div id="about_us">
    <TerrorZoneNavBar />
    <div id="slot-top_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-top_banner" class="desktop-banner hoz-banner"/>
    <Ad placementName="video_slider"/>
    <div class="about-us-content">
      <h1>About Us</h1>
      <p>Welcome to <strong>D2TZ</strong>!</p>
      <p>
        This is a home for devoted fans, nostalgic veterans, and brave adventurers of <em>Diablo II</em>. 
        Founded by a long-time player, this independent site is dedicated to bringing you the 
        <strong>most up-to-date, most practical, and most insightful</strong> content focused on 
        <strong>Terror Zones</strong> in <em>Diablo II: Resurrected</em>.
      </p>
      <p>
        From classic LOD to the remastered era, we’ve walked through Sanctuary countless times and witnessed 
        the thrill of every high rune drop. Whether you're just starting your journey or a seasoned expert in 
        rune words and builds, there's something here for you.
      </p>

      <h3>What you’ll find on this site:</h3>
      <ul>
        <li>Hourly updated Terror Zones information</li>
        <li>Exclusive guides on how to <strong>efficiently farm popular Terror Zones</strong></li>
        <li><strong>Build recommendations and class analysis</strong> tailored for Terror Zone performance</li>
        <li><strong>Unique and Useful</strong> tools to support your runs (Notification App, XP calculators, and more)</li>
      </ul>

      <p>
        We believe in a simple principle: <strong>By players, for players</strong>. 
        Fueled by passion and refined with care, our content aims to help you get more out of every run — with less time wasted.
      </p>

      <p>
        If you’re a fellow Diablo II enthusiast, especially one who loves the challenge and rewards of Terror Zones, 
        you’re in the right place. Welcome to the community!
      </p>

      <p>
        <em>Thank you for visiting. May fortune smile upon your drops,</em><br>
        — <strong>Sheldon</strong>, D2TZ Founder
      </p>
    </div>
    <div id="slot-btm_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-btm_banner" class="desktop-banner hoz-banner"/>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import Ad from './components/Ad.vue'
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'

export default {
  name: 'AboutUs',

  components: {
    Ad,
    TerrorZoneNavBar,
    TerrorZoneFooter,
  },
}
</script>

<style scoped>
.about-us-content {
  color: #fff;
  justify-content: space-around;
  max-width: 900px;
  margin: 40px auto;
  width: 70%;
}
@media (max-width: 600px) {
  .about-us-content {
    width: 90%;
  }
}
</style>
